module.exports = "<itpx-learning-tile [deliverableStatus]=\"deliverableStatus\" [status]=\"status\" [target]=\"target\" [logo]=\"'unknown.png'\" [name]=\"name\" [errorMessage]=\"errorMessage\"  [disabled]=\"deliverable.disabled\" [availableUntil]=\"deliverable.availableUntil\">\n</itpx-learning-tile>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/unknown/tile.component.html
// module id = 867
// module chunks = 0